var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/ui/themes/index.ts
var themes_exports = {};
__export(themes_exports, {
  proTheme: () => theme,
  ucpwTheme: () => theme2
});

// src/ui/themes/pro-theme/index.ts
import { theme as proTheme } from "@chakra-ui/pro-theme";
import { extendTheme, theme as baseTheme } from "@chakra-ui/react";
import "@fontsource/inter/variable.css";
var theme = extendTheme(
  {
    colors: { ...baseTheme.colors, brand: baseTheme.colors.blue }
  },
  proTheme
);

// src/ui/themes/ucpw-theme/index.ts
import { extendTheme as extendTheme2 } from "@chakra-ui/react";

// src/ui/themes/ucpw-theme/components/index.ts
var components_exports = {};
__export(components_exports, {
  Badge: () => badge_default,
  Button: () => button_default,
  CloseButton: () => close_button_default,
  Container: () => container_default,
  CustomSelect: () => custom_select_default,
  Divider: () => divider_default,
  FormLabel: () => form_label_default,
  Heading: () => heading_default,
  Input: () => input_default,
  Progress: () => progress_default,
  RadioCard: () => radio_card_default,
  Table: () => table_default,
  Tabs: () => tabs_default,
  Textarea: () => textarea_default
});

// ../../node_modules/color2k/dist/index.exports.import.es.mjs
function guard(low, high, value) {
  return Math.min(Math.max(low, value), high);
}
var ColorError = class extends Error {
  constructor(color) {
    super(`Failed to parse color: "${color}"`);
  }
};
var ColorError$1 = ColorError;
function parseToRgba(color) {
  if (typeof color !== "string")
    throw new ColorError$1(color);
  if (color.trim().toLowerCase() === "transparent")
    return [0, 0, 0, 0];
  let normalizedColor = color.trim();
  normalizedColor = namedColorRegex.test(color) ? nameToHex(color) : color;
  const reducedHexMatch = reducedHexRegex.exec(normalizedColor);
  if (reducedHexMatch) {
    const arr = Array.from(reducedHexMatch).slice(1);
    return [...arr.slice(0, 3).map((x) => parseInt(r(x, 2), 16)), parseInt(r(arr[3] || "f", 2), 16) / 255];
  }
  const hexMatch = hexRegex.exec(normalizedColor);
  if (hexMatch) {
    const arr = Array.from(hexMatch).slice(1);
    return [...arr.slice(0, 3).map((x) => parseInt(x, 16)), parseInt(arr[3] || "ff", 16) / 255];
  }
  const rgbaMatch = rgbaRegex.exec(normalizedColor);
  if (rgbaMatch) {
    const arr = Array.from(rgbaMatch).slice(1);
    return [...arr.slice(0, 3).map((x) => parseInt(x, 10)), parseFloat(arr[3] || "1")];
  }
  const hslaMatch = hslaRegex.exec(normalizedColor);
  if (hslaMatch) {
    const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
    if (guard(0, 100, s) !== s)
      throw new ColorError$1(color);
    if (guard(0, 100, l) !== l)
      throw new ColorError$1(color);
    return [...hslToRgb(h, s, l), Number.isNaN(a) ? 1 : a];
  }
  throw new ColorError$1(color);
}
function hash(str) {
  let hash2 = 5381;
  let i = str.length;
  while (i) {
    hash2 = hash2 * 33 ^ str.charCodeAt(--i);
  }
  return (hash2 >>> 0) % 2341;
}
var colorToInt = (x) => parseInt(x.replace(/_/g, ""), 36);
var compressedColorMap = "1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm".split(" ").reduce((acc, next) => {
  const key = colorToInt(next.substring(0, 3));
  const hex = colorToInt(next.substring(3)).toString(16);
  let prefix = "";
  for (let i = 0; i < 6 - hex.length; i++) {
    prefix += "0";
  }
  acc[key] = `${prefix}${hex}`;
  return acc;
}, {});
function nameToHex(color) {
  const normalizedColorName = color.toLowerCase().trim();
  const result = compressedColorMap[hash(normalizedColorName)];
  if (!result)
    throw new ColorError$1(color);
  return `#${result}`;
}
var r = (str, amount) => Array.from(Array(amount)).map(() => str).join("");
var reducedHexRegex = new RegExp(`^#${r("([a-f0-9])", 3)}([a-f0-9])?$`, "i");
var hexRegex = new RegExp(`^#${r("([a-f0-9]{2})", 3)}([a-f0-9]{2})?$`, "i");
var rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r(",\\s*(\\d+)\\s*", 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, "i");
var hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
var namedColorRegex = /^[a-z]+$/i;
var roundColor = (color) => {
  return Math.round(color * 255);
};
var hslToRgb = (hue, saturation, lightness) => {
  let l = lightness / 100;
  if (saturation === 0) {
    return [l, l, l].map(roundColor);
  }
  const huePrime = (hue % 360 + 360) % 360 / 60;
  const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
  const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  let red = 0;
  let green = 0;
  let blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  const lightnessModification = l - chroma / 2;
  const finalRed = red + lightnessModification;
  const finalGreen = green + lightnessModification;
  const finalBlue = blue + lightnessModification;
  return [finalRed, finalGreen, finalBlue].map(roundColor);
};
function parseToHsla(color) {
  const [red, green, blue, alpha] = parseToRgba(color).map((value, index) => (
    // 3rd index is alpha channel which is already normalized
    index === 3 ? value : value / 255
  ));
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  const lightness = (max + min) / 2;
  if (max === min)
    return [0, 0, lightness, alpha];
  const delta = max - min;
  const saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  const hue = 60 * (red === max ? (green - blue) / delta + (green < blue ? 6 : 0) : green === max ? (blue - red) / delta + 2 : (red - green) / delta + 4);
  return [hue, saturation, lightness, alpha];
}
function hsla(hue, saturation, lightness, alpha) {
  return `hsla(${(hue % 360).toFixed()}, ${guard(0, 100, saturation * 100).toFixed()}%, ${guard(0, 100, lightness * 100).toFixed()}%, ${parseFloat(guard(0, 1, alpha).toFixed(3))})`;
}
function darken(color, amount) {
  const [hue, saturation, lightness, alpha] = parseToHsla(color);
  return hsla(hue, saturation, lightness - amount, alpha);
}
function rgba(red, green, blue, alpha) {
  return `rgba(${guard(0, 255, red).toFixed()}, ${guard(0, 255, green).toFixed()}, ${guard(0, 255, blue).toFixed()}, ${parseFloat(guard(0, 1, alpha).toFixed(3))})`;
}
function transparentize(color, amount) {
  const [r2, g, b, a] = parseToRgba(color);
  return rgba(r2, g, b, a - amount);
}
function toHex(color) {
  const [r2, g, b, a] = parseToRgba(color);
  let hex = (x) => {
    const h = guard(0, 255, x).toString(16);
    return h.length === 1 ? `0${h}` : h;
  };
  return `#${hex(r2)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ""}`;
}

// ../../node_modules/@chakra-ui/theme-tools/dist/chunk-H4E5VM26.mjs
function dlv_es_default(t, e, l, n, r2) {
  for (e = e.split ? e.split(".") : e, n = 0; n < e.length; n++)
    t = t ? t[e[n]] : r2;
  return t === r2 ? l : t;
}
var getColor = (theme3, color, fallback) => {
  const hex = dlv_es_default(theme3, `colors.${color}`, color);
  try {
    toHex(hex);
    return hex;
  } catch {
    return fallback != null ? fallback : "#000000";
  }
};
var transparentize2 = (color, opacity) => (theme3) => {
  const raw = getColor(theme3, color);
  return transparentize(raw, 1 - opacity);
};
var darken2 = (color, amount) => (theme3) => {
  const raw = getColor(theme3, color);
  return toHex(darken(raw, amount / 100));
};

// ../../node_modules/@chakra-ui/theme-tools/dist/chunk-7P3W45AB.mjs
function mode(light, dark) {
  return (props) => props.colorMode === "dark" ? dark : light;
}

// src/ui/themes/ucpw-theme/components/badge.ts
var baseStyle = {
  textTransform: "normal",
  fontWeight: "medium",
  borderRadius: "2xl"
};
var sizes = {
  lg: {
    fontSize: "sm",
    px: "3",
    py: "1"
  },
  md: {
    fontSize: "sm",
    lineHeight: "1.25rem",
    px: "2.5",
    py: "0.5"
  },
  sm: {
    fontSize: "xs",
    lineHeight: "1.5",
    px: "2",
    py: "0.5"
  }
};
var variants = {
  subtle: (props) => ({
    bg: mode(
      darken2(`${props.colorScheme}.50`, 2)(props.theme),
      transparentize2(`${props.colorScheme}.200`, 0.16)(props.theme)
    )(props)
  })
};
var defaultProps = {
  size: "md",
  variant: "subtle"
};
var badge_default = {
  baseStyle,
  defaultProps,
  variants,
  sizes
};

// src/ui/themes/ucpw-theme/components/button.ts
var baseStyle2 = {
  ":focus:not(:focus-visible)": {
    boxShadow: "none"
  },
  fontWeight: "medium",
  borderRadius: "lg"
};
var sizes2 = {
  lg: {
    fontSize: "md"
  }
};
var variants2 = {
  primary: (props) => props.theme.components["Button"]["variants"]["solid"]({
    ...props,
    variant: "solid",
    colorScheme: "brand"
  }),
  "primary-on-accent": () => ({
    bg: "brand.50",
    color: "brand.600",
    _hover: { bg: "brand.100" },
    _active: { bg: "brand.100" }
  }),
  secondary: (props) => props.theme.components["Button"]["variants"]["outline"]({
    ...props,
    variant: "outline",
    colorScheme: "gray"
  }),
  "secondary-on-accent": {
    color: "white",
    borderColor: "brand.50",
    borderWidth: "1px",
    _hover: { bg: "whiteAlpha.200" },
    _active: { bg: "whiteAlpha.200" }
  },
  outline: (props) => ({
    color: "emphasized",
    bg: mode("white", "gray.800")(props),
    _hover: {
      bg: mode(
        darken2("gray.50", 1)(props.theme),
        transparentize2("gray.700", 0.4)(props.theme)
      )(props)
    },
    _checked: {
      bg: mode("gray.100", "gray.700")(props)
    },
    _active: {
      bg: mode("gray.100", "gray.700")(props)
    }
  }),
  ghost: (props) => ({
    color: "emphasized",
    _hover: {
      bg: mode(darken2("gray.50", 1)(props.theme), darken2("gray.700", 4)(props.theme))(props)
    },
    _active: {
      bg: mode(darken2("gray.50", 1)(props.theme), darken2("gray.700", 4)(props.theme))(props)
    },
    _activeLink: {
      bg: mode("gray.100", "gray.700")(props)
    }
  }),
  "ghost-on-accent": (props) => ({
    color: "brand.50",
    _hover: {
      bg: transparentize2("brand.500", 0.67)(props.theme)
    },
    _activeLink: {
      color: "white",
      bg: "bg-accent-subtle"
    }
  }),
  link: (props) => {
    if (props.colorScheme === "gray") {
      return {
        color: "muted",
        _hover: {
          textDecoration: "none",
          color: "default"
        },
        _active: {
          color: "default"
        }
      };
    }
    return {
      color: mode(`${props.colorScheme}.600`, `${props.colorScheme}.200`)(props),
      _hover: {
        color: mode(`${props.colorScheme}.700`, `${props.colorScheme}.300`)(props),
        textDecoration: "none"
      },
      _active: {
        color: mode(`${props.colorScheme}.700`, `${props.colorScheme}.300`)(props)
      }
    };
  },
  "link-on-accent": () => {
    return {
      padding: 0,
      height: "auto",
      lineHeight: "normal",
      verticalAlign: "baseline",
      color: "brand.50",
      _hover: {
        color: "white"
      },
      _active: {
        color: "white"
      }
    };
  }
};
var button_default = {
  baseStyle: baseStyle2,
  variants: variants2,
  sizes: sizes2
};

// src/ui/themes/ucpw-theme/components/close-button.ts
var baseStyle3 = {
  _focus: {
    boxShadow: "none"
  },
  _focusVisible: {
    boxShadow: "outline"
  }
};
var close_button_default = {
  baseStyle: baseStyle3
};

// src/ui/themes/ucpw-theme/components/container.ts
var baseStyle4 = {
  maxW: "7xl",
  px: { base: "4", md: "8" }
};
var container_default = { baseStyle: baseStyle4 };

// src/ui/themes/ucpw-theme/components/custom-select.ts
var parts = ["field", "menu", "option"];
var baseStyle5 = {
  field: {
    width: "100%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 50ms ease"
  },
  option: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  },
  menu: {
    minW: "3xs"
  }
};
var variants3 = {
  outline: (props) => ({
    menu: {
      bg: mode("white", "gray.800")(props),
      boxShadow: mode("sm", "sm-dark")(props),
      color: "inherit",
      minW: "3xs",
      py: "2",
      borderRadius: "md",
      borderWidth: "1px"
    },
    option: {
      _selected: {
        bg: mode("gray.100", "gray.700")(props)
      }
    },
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: mode("white", "gray.800")(props),
      _hover: {
        borderColor: mode("gray.300", "whiteAlpha.400")(props)
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        borderColor: "inherit"
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: getColor(props.theme, mode("red.500", "red.300")(props)),
        boxShadow: `0 0 0 1px ${getColor(props.theme, mode("red.500", "red.300")(props))}`
      },
      _focus: {
        borderColor: mode("brand.500", "brand.200")(props),
        boxShadow: mode(
          `0px 0px 0px 1px ${transparentize2(`brand.500`, 1)(props.theme)}`,
          `0px 0px 0px 1px ${transparentize2(`brand.200`, 1)(props.theme)}`
        )(props)
      },
      _expanded: {
        borderColor: mode("brand.500", "brand.200")(props),
        boxShadow: mode(
          `0px 0px 0px 1px ${transparentize2(`brand.500`, 1)(props.theme)}`,
          `0px 0px 0px 1px ${transparentize2(`brand.200`, 1)(props.theme)}`
        )(props)
      }
    }
  })
};
var sizes3 = {
  sm: {
    field: {
      px: 3,
      h: 8,
      fontSize: "sm",
      borderRadius: "sm"
    },
    menu: {
      fontSize: "sm",
      borderRadius: "sm"
    },
    option: {
      px: 3,
      h: 8,
      fontSize: "sm"
    }
  },
  md: {
    field: {
      px: 4,
      h: 10,
      fontSize: "md",
      borderRadius: "md"
    },
    menu: {
      fontSize: "md",
      borderRadius: "md"
    },
    option: {
      px: 4,
      h: 10,
      fontSize: "md"
    }
  },
  lg: {
    field: {
      px: 4,
      h: 12,
      fontSize: "lg",
      borderRadius: "md"
    },
    menu: {
      fontSize: "lg",
      borderRadius: "md"
    },
    option: {
      px: 4,
      h: 12,
      fontSize: "lg"
    }
  }
};
var custom_select_default = {
  parts,
  baseStyle: baseStyle5,
  variants: variants3,
  sizes: sizes3,
  defaultProps: {
    size: "md",
    variant: "outline",
    colorScheme: "brand"
  }
};

// src/ui/themes/ucpw-theme/components/divider.ts
var divider_default = {
  baseStyle: {
    opacity: 1
  }
};

// src/ui/themes/ucpw-theme/components/form-label.ts
var baseStyle6 = {
  color: "emphasized",
  mb: "1.5",
  fontSize: "sm"
};
var sizes4 = {
  sm: {
    _peerPlaceholderShown: {
      fontSize: "sm",
      top: "1.5",
      left: "4"
    }
  },
  md: {
    _peerPlaceholderShown: {
      fontSize: "md",
      top: "2",
      left: "4"
    }
  },
  lg: {
    _peerPlaceholderShown: {
      fontSize: "lg",
      top: "2.5",
      left: "4"
    }
  }
};
var variants4 = {
  inline: () => ({
    margin: 0,
    minW: "2xs"
  }),
  floating: () => ({
    position: "absolute",
    transition: "all 0.12s ease-in",
    pointerEvents: "none",
    top: "-27px",
    left: "0",
    _peerPlaceholderShown: {
      fontWeight: "normal",
      color: "subtle"
    },
    _peerFocus: {
      fontSize: "sm",
      fontWeight: "medium",
      top: "-27px",
      left: "0",
      color: "muted"
    }
  })
};
var defaultProps2 = {
  size: "md"
};
var form_label_default = {
  baseStyle: baseStyle6,
  sizes: sizes4,
  variants: variants4,
  defaultProps: defaultProps2
};

// src/ui/themes/ucpw-theme/components/heading.ts
var baseStyle7 = {
  fontWeight: "semibold"
};
var sizes5 = {
  "2xl": {
    fontSize: "7xl",
    lineHeight: "5.625rem",
    letterSpacing: "tight"
  },
  xl: {
    fontSize: "6xl",
    lineHeight: "4.5rem",
    letterSpacing: "tight"
  },
  lg: {
    fontSize: "5xl",
    lineHeight: "3.75rem",
    letterSpacing: "tight"
  },
  md: {
    fontSize: "4xl",
    lineHeight: "2.75rem",
    letterSpacing: "tight"
  },
  sm: {
    fontSize: "3xl",
    lineHeight: "2.375rem"
  },
  xs: {
    fontSize: "2xl",
    lineHeight: "2rem"
  }
};
var heading_default = {
  baseStyle: baseStyle7,
  sizes: sizes5
};

// src/ui/themes/ucpw-theme/components/input.ts
var variants5 = {
  outline: (props) => ({
    field: {
      borderRadius: "lg",
      bg: mode("white", "gray.800")(props),
      _hover: { borderColor: mode("gray.300", "gray.600")(props) },
      _focus: {
        borderColor: mode("brand.500", "brand.200")(props),
        boxShadow: mode(
          `0px 0px 0px 1px ${transparentize2(`brand.500`, 1)(props.theme)}`,
          `0px 0px 0px 1px ${transparentize2(`brand.200`, 1)(props.theme)}`
        )(props)
      }
    },
    addon: {
      borderRadius: "lg",
      bg: mode("gray.50", "gray.700")(props)
    }
  }),
  "outline-on-accent": (props) => ({
    field: {
      bg: "white",
      borderRadius: "lg",
      color: "gray.900",
      borderWidth: "1px",
      borderColor: "brand.50",
      _placeholder: {
        color: "gray.500"
      },
      _hover: {
        borderColor: "brand.100"
      },
      _focus: {
        borderColor: "brand.200",
        boxShadow: `0px 0px 0px 1px ${transparentize2(`brand.200`, 1)(props.theme)}`
      }
    }
  }),
  filled: (props) => {
    if (props.colorScheme === "gray") {
      return {
        field: {
          bg: mode("white", "gray.800")(props),
          _hover: {
            borderColor: mode("gray.200", "gray.700")(props),
            bg: mode("white", "gray.700")(props)
          },
          _focus: {
            borderColor: "accent",
            bg: mode("white", "gray.800")(props)
          }
        }
      };
    }
    return {
      field: {
        bg: "bg-accent-subtle",
        color: "on-accent",
        _placeholder: {
          color: "on-accent"
        },
        _hover: {
          borderColor: "brand.400",
          bg: "bg-accent-subtle"
        },
        _focus: {
          bg: "bg-accent-subtle",
          borderColor: "brand.300"
        }
      }
    };
  }
};
var input_default = {
  variants: variants5,
  defaultProps: {
    colorScheme: "gray"
  }
};

// src/ui/themes/ucpw-theme/components/progress.ts
var baseStyle8 = {
  track: {
    borderRadius: "base"
  }
};
var variants6 = {
  solid: {
    track: {
      bg: "bg-muted"
    }
  },
  "on-accent": {
    track: {
      bg: "transparent"
    },
    filledTrack: {
      bg: "brand.50"
    }
  }
};
var defaultProps3 = {
  colorScheme: "brand",
  variant: "solid"
};
var progress_default = {
  variants: variants6,
  baseStyle: baseStyle8,
  defaultProps: defaultProps3
};

// src/ui/themes/ucpw-theme/components/radio-card.ts
var baseStyle9 = (props) => ({
  borderWidth: "1px",
  borderRadius: "lg",
  p: "4",
  bg: "bg-surface",
  transitionProperty: "common",
  transitionDuration: "normal",
  _hover: { borderColor: mode("gray.300", "gray.600")(props) },
  _checked: {
    borderColor: mode("brand.500", "brand.200")(props),
    boxShadow: mode(
      `0px 0px 0px 1px ${transparentize2(`brand.500`, 1)(props.theme)}`,
      `0px 0px 0px 1px ${transparentize2(`brand.200`, 1)(props.theme)}`
    )(props)
  }
});
var radio_card_default = {
  baseStyle: baseStyle9
};

// src/ui/themes/ucpw-theme/components/table.ts
var baseStyle10 = {
  table: {
    bg: "bg-surface",
    whiteSpace: "nowrap"
  },
  th: {
    fontWeight: "medium",
    textTransform: "normal",
    letterSpacing: "normal",
    borderTopWidth: "1px",
    whiteSpace: "nowrap"
  }
};
var variants7 = {
  simple: (props) => ({
    th: {
      color: "muted",
      bg: mode("gray.50", transparentize2("gray.700", 0.4)(props.theme))(props)
    }
  }),
  striped: (props) => ({
    th: {
      color: "muted",
      borderBottomWidth: "0px"
    },
    tbody: {
      tr: {
        "th,td": {
          borderWidth: "0px"
        },
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "0px"
          },
          td: {
            bg: mode("gray.50", transparentize2("gray.700", 0.4)(props.theme))(props)
          }
        }
      }
    }
  })
};
var sizes6 = {
  md: {
    th: {
      lineHeight: "1.25rem"
    },
    td: {
      fontSize: "sm"
    }
  }
};
var table_default = {
  sizes: sizes6,
  baseStyle: baseStyle10,
  variants: variants7
};

// src/ui/themes/ucpw-theme/components/tabs.ts
var baseStyle11 = {
  tab: {
    fontWeight: "medium",
    color: "muted",
    _focus: {
      boxShadow: "none"
    },
    _focusVisible: {
      boxShadow: "base"
    }
  }
};
var variants8 = {
  line: {
    tab: {
      _selected: {
        color: "accent",
        borderColor: "accent"
      },
      _active: {
        bg: "transparent"
      }
    }
  },
  enclosed: {
    tab: {
      _selected: {
        color: "accent"
      }
    }
  }
};
var sizes7 = {
  md: {
    tab: {
      fontSize: "sm"
    }
  }
};
var tabs_default = { baseStyle: baseStyle11, variants: variants8, sizes: sizes7 };

// src/ui/themes/ucpw-theme/components/textarea.ts
var variants9 = {
  outline: (props) => ({
    borderRadius: "lg",
    bg: mode("white", "gray.800")(props),
    _hover: { borderColor: mode("gray.300", "gray.600")(props) },
    _focus: {
      borderColor: mode("brand.500", "brand.200")(props),
      boxShadow: mode(
        `0px 0px 0px 1px ${transparentize2(`brand.500`, 1)(props.theme)}`,
        `0px 0px 0px 1px ${transparentize2(`brand.200`, 1)(props.theme)}`
      )(props)
    }
  })
};
var textarea_default = {
  variants: variants9
};

// src/ui/themes/ucpw-theme/foundations/index.ts
var foundations_exports = {};
__export(foundations_exports, {
  fonts: () => fonts_default,
  semanticTokens: () => tokens_default,
  shadows: () => shadows_default,
  styles: () => styles_default
});

// src/ui/themes/ucpw-theme/foundations/fonts.ts
var fonts_default = {
  heading: "InterVariable, -apple-system, system-ui, sans-serif",
  body: "InterVariable, -apple-system, system-ui, sans-serif"
};

// src/ui/themes/ucpw-theme/foundations/shadows.ts
var shadows_default = {
  xs: "0px 1px 2px rgba(16, 24, 40, 0.05)",
  sm: "0px 0px 1px rgba(48, 49, 51, 0.05), 0px 2px 4px rgba(48, 49, 51, 0.1)",
  md: "0px 0px 1px rgba(48, 49, 51, 0.05), 0px 4px 8px rgba(48, 49, 51, 0.1)",
  lg: "0px 0px 1px rgba(48, 49, 51, 0.05), 0px 8px 16px rgba(48, 49, 51, 0.1)",
  xl: "0px 0px 1px rgba(48, 49, 51, 0.05), 0px 16px 24px rgba(48, 49, 51, 0.1)",
  "xs-dark": "0px 1px 3px rgba(11, 12, 17, 0.9)",
  "sm-dark": "0px 2px 4px rgba(11, 12, 17, 0.9)",
  "md-dark": "0px 4px 8px rgba(11, 12, 17, 0.9)",
  "lg-dark": "0px 8px 16px rgba(11, 12, 17, 0.9)",
  "xl-dark": "0px 16px 24px rgba(11, 12, 17, 0.9)"
};

// src/ui/themes/ucpw-theme/foundations/mobiscroll.ts
var mobiscroll = {
  ".mbsc-schedule-event-hover, .mbsc-schedule-event-dragging": {
    "& .mbsc-schedule-event-resize.mbsc-schedule-event-resize-start.mbsc-ltr:after": {
      display: "none"
    },
    "& .mbsc-schedule-event-resize.mbsc-schedule-event-resize-end.mbsc-ltr:after": {
      display: "none"
    }
  },
  ".mbsc-ios.mbsc-calendar-controls": {
    padding: 0
  },
  ".mbsc-schedule-grid-scroll": { cursor: "copy" },
  ".mbsc-schedule-resource-title": {
    p: 0
  },
  ".mbsc-schedule-date-header.mbsc-flex.mbsc-ios": {
    display: "none"
  },
  ".mbsc-ios.mbsc-schedule-time": { color: "gray.700" },
  ".mbsc-ios.mbsc-schedule-header, .mbsc-ios.mbsc-schedule-header-item": {
    borderColor: "gray.200",
    borderTopWidth: "1px",
    bg: "gray.50"
  },
  ".mbsc-ios.mbsc-schedule-item": {
    borderColor: "gray.200"
  },
  ".mbsc-ios.mbsc-schedule-header-day.mbsc-selected": {
    background: "blue.500"
  },
  ".mbsc-ios.mbsc-schedule-header-day-today": {
    color: "blue.500"
  },
  ".mbsc-schedule-header-day": {
    color: "gray.600"
  },
  ".mbsc-ios.mbsc-schedule-header-dayname": {
    color: "gray.600"
  },
  ".mbsc-ios.mbsc-schedule-header-dayname-curr": {
    color: "gray.600"
  },
  ".mbsc-calendar-button.mbsc-button.mbsc-reset": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    "span:first-of-type": {
      fontWeight: 700,
      color: "gray.900",
      fontSize: 18,
      lineHeight: "28px",
      mb: 1
    },
    "& span": {
      color: "gray.600",
      p: 0,
      fontWeight: 400,
      fontSize: 14,
      lineHeight: "20px"
    }
  },
  ".mbsc-ios.mbsc-schedule-all-day-wrapper": { display: "none" },
  ".mbsc-ios.mbsc-eventcalendar .mbsc-calendar-header, .mbsc-ios.mbsc-eventcalendar .mbsc-calendar-week-days": {
    background: "transparent"
  },
  ".mbsc-ios.mbsc-form-control-wrapper:after, .mbsc-ios.mbsc-form-control-wrapper:before": {
    content: "''",
    position: "absolute",
    borderTop: "0px solid transparent"
  }
};

// src/ui/themes/ucpw-theme/foundations/webkitLineClamp.ts
var webkitLineClamp = {
  ".line-clamp-3": {
    display: "-webkit-box",
    webkitLineClamp: "3",
    webkitBoxOrient: "vertical",
    overflow: "hidden"
  }
};

// src/ui/themes/ucpw-theme/foundations/styles.ts
var styles_default = {
  global: (props) => ({
    body: {
      ...mobiscroll,
      ...webkitLineClamp,
      color: "default",
      bg: "bg-canvas"
    },
    "*::placeholder": {
      opacity: 1,
      color: "subtle"
    },
    "*, *::before, &::after": {
      // FIXME: next line
      // borderColor: mode('gray.200', lighten('gray.700', 3)(props.theme))(props),
    }
  })
};

// src/ui/themes/ucpw-theme/foundations/tokens.ts
var tokens_default = {
  colors: {
    "bg-canvas": {
      default: "gray.50",
      _dark: "gray.900"
    },
    "bg-surface": {
      default: "white",
      _dark: "gray.800"
    },
    "bg-subtle": {
      default: "gray.50",
      _dark: "gray.700"
    },
    "bg-muted": {
      default: "gray.100",
      _dark: "gray.600"
    },
    default: {
      default: "gray.900",
      _dark: "white"
    },
    inverted: {
      default: "white",
      _dark: "gray.900"
    },
    emphasized: {
      default: "gray.700",
      _dark: "gray.100"
    },
    muted: {
      default: "gray.600",
      _dark: "gray.300"
    },
    subtle: {
      default: "gray.500",
      _dark: "gray.400"
    },
    border: {
      default: "gray.200",
      _dark: "#333e51"
      // lighten('gray.700', 3)(props.theme)
    },
    accent: {
      default: "brand.500",
      _dark: "brand.200"
    },
    success: {
      default: "green.600",
      _dark: "green.200"
    },
    error: {
      default: "red.600",
      _dark: "red.200"
    },
    "bg-accent": "brand.600",
    "bg-accent-subtle": "brand.500",
    "bg-accent-muted": "brand.400",
    "on-accent": "white",
    "on-accent-muted": "brand.50",
    "on-accent-subtle": "brand.100"
  }
};

// src/ui/themes/ucpw-theme/ucpw/foundations/index.ts
var foundations_exports2 = {};
__export(foundations_exports2, {
  semanticTokens: () => tokens_default2
});

// src/ui/themes/ucpw-theme/ucpw/foundations/tokens.ts
var tokens_default2 = {
  colors: {
    "ucpw-brand": "#2687C7",
    "bg-accent": { default: "gray.50", _dark: "gray.800" },
    "bg-canvas": "inverted",
    "bg-accent-subtle": "border",
    "on-accent": "subtle",
    "brand.50": "on-accent"
  }
};

// src/ui/themes/ucpw-theme/ucpw/components/index.ts
var components_exports2 = {};
__export(components_exports2, {
  Button: () => button_default2
});

// src/ui/themes/ucpw-theme/ucpw/components/button.ts
var variants10 = {
  "ghost-on-accent": () => ({
    color: "gray.700",
    _hover: {
      bg: "ucpw-brand",
      color: "inverted"
    },
    _activeLink: {
      bg: "none",
      color: "ucpw-brand"
    }
  })
};
var button_default2 = {
  variants: variants10
};

// src/ui/themes/ucpw-theme/index.ts
var config = {
  initialColorMode: "light",
  useSystemColorMode: false
};
var theme2 = extendTheme2(
  {
    config,
    ...foundations_exports,
    components: { ...components_exports }
  },
  {
    config,
    ...foundations_exports2,
    components: { ...components_exports2 }
  }
);

// src/ui/hooks/useCustomEvent.tsx
function useCustomEvent() {
  function subscribe(eventName, listener) {
    document.addEventListener(eventName, listener);
  }
  function unsubscribe(eventName, listener) {
    document.removeEventListener(eventName, listener);
  }
  function publish(eventName, data) {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  }
  return { publish, subscribe, unsubscribe };
}

// src/ui/Login.tsx
import React from "react";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  Stack,
  useBreakpointValue,
  useColorModeValue,
  IconButton,
  InputGroup,
  InputRightElement,
  useDisclosure
} from "@chakra-ui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var SignIn = ({ signIn }) => {
  const { isOpen, onToggle } = useDisclosure();
  const inputRef = React.useRef(null);
  const [status, setStatus] = React.useState("idle");
  const isLoading = status === "loading";
  const onClickReveal = () => {
    onToggle();
    if (inputRef.current) {
      inputRef.current.focus({ preventScroll: true });
    }
  };
  return /* @__PURE__ */ jsx(Container, { maxW: "lg", py: { base: "12", md: "24" }, px: { base: "0", sm: "8" }, h: "90vh", children: /* @__PURE__ */ jsxs(Stack, { spacing: "6", justify: "space-between", h: "full", children: [
    /* @__PURE__ */ jsxs(Stack, { spacing: { base: "2", md: "3" }, textAlign: "center", children: [
      /* @__PURE__ */ jsx(
        Heading,
        {
          className: "signInHeading",
          size: useBreakpointValue({ base: "xs", md: "sm" }),
          children: "Sign in to your account"
        }
      ),
      /* @__PURE__ */ jsx(
        Box,
        {
          py: { base: "0", sm: "8" },
          px: { base: "4", sm: "10" },
          bg: useBreakpointValue({ base: "transparent", sm: "bg-surface" }),
          boxShadow: { base: "none", sm: useColorModeValue("md", "md-dark") },
          borderRadius: { base: "none", sm: "xl" },
          children: /* @__PURE__ */ jsx("form", { onSubmit: (e) => e.preventDefault(), children: /* @__PURE__ */ jsxs(Stack, { spacing: "6", children: [
            /* @__PURE__ */ jsxs(Stack, { spacing: "5", children: [
              /* @__PURE__ */ jsxs(FormControl, { children: [
                /* @__PURE__ */ jsx(FormLabel, { htmlFor: "email", children: "Email" }),
                /* @__PURE__ */ jsx(Input, { type: "email", name: "username", "data-testid": "email-input" })
              ] }),
              /* @__PURE__ */ jsxs(FormControl, { children: [
                /* @__PURE__ */ jsxs(HStack, { justify: "space-between", children: [
                  /* @__PURE__ */ jsx(FormLabel, { htmlFor: "password", children: "Password" }),
                  /* @__PURE__ */ jsx(Button, { variant: "link", colorScheme: "blue", size: "sm", children: "Forgot password?" })
                ] }),
                /* @__PURE__ */ jsxs(InputGroup, { children: [
                  /* @__PURE__ */ jsx(InputRightElement, { children: /* @__PURE__ */ jsx(
                    IconButton,
                    {
                      variant: "link",
                      "aria-label": isOpen ? "Mask password" : "Reveal password",
                      onClick: onClickReveal
                    }
                  ) }),
                  /* @__PURE__ */ jsx(
                    Input,
                    {
                      name: "password",
                      "data-testid": "password-input",
                      type: isOpen ? "text" : "password",
                      autoComplete: "current-password",
                      required: true
                    }
                  )
                ] })
              ] })
            ] }),
            /* @__PURE__ */ jsx(Stack, { spacing: "6", children: /* @__PURE__ */ jsx(
              Button,
              {
                type: "submit",
                variant: "primary",
                isLoading,
                loadingText: "Sign in",
                children: "Sign in"
              }
            ) })
          ] }) })
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Box, {})
  ] }) });
};

// src/ui/DataTable/DataTable.tsx
import * as React3 from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  chakra,
  Box as Box2,
  useColorModeValue as mode2,
  Skeleton,
  SimpleGrid,
  GridItem
} from "@chakra-ui/react";
import { TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";
import { FaCheck } from "react-icons/fa";
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  getSortedRowModel
} from "@tanstack/react-table";

// src/ui/DataTable/DataTablePagination.tsx
import React2 from "react";
import { FiChevronLeft, FiChevronsLeft, FiChevronRight, FiChevronsRight } from "react-icons/fi";
import { Button as Button2, IconButton as IconButton2, HStack as HStack2 } from "@chakra-ui/react";
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var PageButton = ({ active, ...props }) => /* @__PURE__ */ jsx2(
  Button2,
  {
    size: "sm",
    minWidth: 7,
    variant: "ghost",
    _hover: {
      color: "blue.500"
    },
    ...props
  }
);
function DataTablePagination({
  actualPageCount = 0,
  table = {},
  loading = false
}) {
  const [preservedPageCount, setPreservedPageCount] = React2.useState(0);
  React2.useEffect(() => {
    if (table?.getPageCount?.() > 0) {
      setPreservedPageCount(table?.getPageCount?.());
    }
  }, [table?.getPageCount?.()]);
  React2.useEffect(() => {
    if (actualPageCount > preservedPageCount) {
      table?.setPageIndex(0);
    }
  }, [actualPageCount, preservedPageCount]);
  const [pageIndex, setPageIndex] = React2.useState(0);
  const getPageButtonProps = (idx) => ({
    active: pageIndex + 1 === idx,
    ...pageIndex + 1 === idx && { variant: "outline", color: "blue.500" },
    children: idx,
    onClick: () => {
      table?.setPageIndex?.(idx - 1);
    }
  });
  React2.useEffect(() => {
    setPageIndex(table?.getState?.()?.pagination?.pageIndex);
  }, [table.getState?.()?.pagination?.pageIndex]);
  if (preservedPageCount === 0 && table?.getPageCount?.() === 0 || table?.getPageCount?.() === 1) {
    return null;
  }
  return /* @__PURE__ */ jsx2(Fragment, { children: /* @__PURE__ */ jsxs2(HStack2, { py: 2, w: "full", alignItems: "center", justifyContent: "flex-end", spacing: 1, children: [
    /* @__PURE__ */ jsx2(
      IconButton2,
      {
        "data-test-id": `table-pagination-first`,
        "aria-label": "pagination-first",
        variant: "ghost",
        icon: /* @__PURE__ */ jsx2(FiChevronsLeft, {}),
        onClick: () => table?.setPageIndex(0),
        disabled: !table?.getCanPreviousPage?.()
      }
    ),
    /* @__PURE__ */ jsx2(
      IconButton2,
      {
        "data-test-id": `table-pagination-prev`,
        "aria-label": "pagination-previous",
        variant: "ghost",
        icon: /* @__PURE__ */ jsx2(FiChevronLeft, {}),
        onClick: () => table?.previousPage?.(),
        disabled: !table?.getCanPreviousPage?.()
      }
    ),
    preservedPageCount < 9 && Array.from({ length: preservedPageCount }).map(
      (_, idx) => /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(idx + 1) }, `page-button:${idx + 1}`)
    ),
    preservedPageCount >= 9 && /* @__PURE__ */ jsxs2(Fragment, { children: [
      /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(1) }),
      (pageIndex < 3 || pageIndex >= preservedPageCount - 3) && /* @__PURE__ */ jsxs2(Fragment, { children: [
        /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(2) }),
        /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(3) })
      ] }),
      pageIndex >= 3 && /* @__PURE__ */ jsx2(PageButton, { "data-test-id": `table-pagination-dots`, pointerEvents: "none", children: "..." }),
      pageIndex === 2 && /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(4) }),
      pageIndex > 2 && pageIndex < preservedPageCount - 3 && /* @__PURE__ */ jsxs2(Fragment, { children: [
        /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(pageIndex) }),
        /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(pageIndex + 1) }),
        /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(pageIndex + 2) })
      ] }),
      pageIndex < preservedPageCount - 3 && /* @__PURE__ */ jsx2(PageButton, { "data-test-id": `table-pagination-dots`, pointerEvents: "none", children: "..." }),
      pageIndex === preservedPageCount - 3 && /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(preservedPageCount - 3) }),
      (pageIndex < 3 || pageIndex >= preservedPageCount - 3) && /* @__PURE__ */ jsxs2(Fragment, { children: [
        /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(preservedPageCount - 2) }),
        /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(preservedPageCount - 1) })
      ] }),
      /* @__PURE__ */ jsx2(PageButton, { ...getPageButtonProps(preservedPageCount) })
    ] }),
    /* @__PURE__ */ jsx2(
      IconButton2,
      {
        "data-test-id": `table-pagination-next`,
        "aria-label": "pagination-next",
        variant: "ghost",
        icon: /* @__PURE__ */ jsx2(FiChevronRight, {}),
        onClick: () => table?.nextPage?.(),
        disabled: !table?.getCanNextPage?.()
      }
    ),
    /* @__PURE__ */ jsx2(
      IconButton2,
      {
        "data-test-id": `table-pagination-last`,
        "aria-label": "pagination-last",
        variant: "ghost",
        icon: /* @__PURE__ */ jsx2(FiChevronsRight, {}),
        onClick: () => table?.setPageIndex?.(table?.getPageCount?.() - 1),
        disabled: !table?.getCanNextPage?.()
      }
    )
  ] }) });
}

// src/ui/DataTable/DataTable.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
function DataTable({
  data = [],
  columns,
  hiddenColumns = [],
  filter = {},
  fetchData,
  onSortChange,
  pageSize: controlledPageSize = 20,
  loadingLength = 0,
  pageIndex: controlledPageIndex = 0,
  pageCount,
  loading = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  activeRow: controlledActiveRow = "",
  activeChecked = false,
  enableSorting = true,
  dataTestId,
  sortBy: controlledSortBy = []
}) {
  const [{ pageIndex, pageSize }, setPagination] = React3.useState({
    pageIndex: controlledPageIndex,
    pageSize: controlledPageSize
  });
  const resetPagination = () => setPagination({ pageIndex: 0, pageSize: controlledPageSize });
  const defaultData = React3.useMemo(() => [], []);
  const [activeRow, setActiveRow] = React3.useState(controlledActiveRow);
  const [sortBy, setSortBy] = React3.useState(controlledSortBy);
  const pagination = React3.useMemo(
    () => ({
      pageIndex,
      pageSize
    }),
    [pageIndex, pageSize]
  );
  const cols = React3.useMemo(
    () => enableSorting ? columns : columns.map((col) => ({ ...col, enableSorting: false })),
    [enableSorting, columns]
  );
  const table = useReactTable({
    data: data.slice(0, pageSize) ?? defaultData,
    columns: cols,
    pageCount: pageCount ?? -1,
    state: {
      sorting: sortBy,
      pagination,
      columnVisibility: hiddenColumns.reduce(
        (acc, column) => ({ ...acc, [column]: false }),
        {}
      )
    },
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    onSortingChange: setSortBy,
    getSortedRowModel: getSortedRowModel(),
    enableSortingRemoval: false,
    manualPagination: true,
    manualSorting: true,
    enableSorting: true,
    sortDescFirst: false
  });
  React3.useEffect(() => {
    fetchData?.(
      {
        pageIndex,
        pageSize,
        sortBy,
        filter
      },
      resetPagination
    );
  }, [fetchData, pageIndex, pageSize, sortBy, filter, resetPagination]);
  React3.useEffect(() => {
    let isMounted = true;
    if (isMounted && sortBy?.length && typeof onSortChange === "function") {
      onSortChange?.({ sortBy });
    }
    return () => {
      isMounted = false;
    };
  }, [sortBy, onSortChange]);
  const hasNoData = !loading && data.length === 0;
  return /* @__PURE__ */ jsxs3(Box2, { overflow: "auto", ...dataTestId && { "data-test-id": dataTestId }, children: [
    /* @__PURE__ */ jsxs3(Table, { borderWidth: "1px", children: [
      /* @__PURE__ */ jsx3(Thead, { bg: mode2("gray.50", "gray.800"), children: table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsx3(Tr, { children: headerGroup.headers.map((header) => {
        const meta = header.column.columnDef.meta;
        const { whiteSpace = "nowrap" } = header?.column?.columnDef || {};
        const { width } = header.column;
        const enableSorting2 = header.column.columnDef.enableSorting ?? true;
        const onClick2 = () => {
          const status = header.column.getIsSorted();
          return status === "desc" ? () => setSortBy([]) : header.column.getToggleSortingHandler();
        };
        return /* @__PURE__ */ jsxs3(
          Th,
          {
            overflow: "hidden",
            textOverflow: "ellipsis",
            userSelect: "none",
            onClick: onClick2(),
            isNumeric: meta?.isNumeric,
            ...width && {
              width: typeof width === "number" ? `${width}` : width
            },
            whiteSpace,
            children: [
              header.id === "controls" ? null : flexRender(
                header.column.columnDef.header,
                header.getContext()
              ),
              /* @__PURE__ */ jsx3(
                chakra.span,
                {
                  pl: "4",
                  ...{
                    ...enableSorting2 ? {
                      visibility: header.column.getIsSorted() ? "revert" : "hidden"
                    } : { display: "none" }
                  },
                  children: header.column.getIsSorted() === "desc" ? /* @__PURE__ */ jsx3(TriangleDownIcon, { "aria-label": "sorted descending" }) : /* @__PURE__ */ jsx3(TriangleUpIcon, { "aria-label": "sorted ascending" })
                }
              )
            ]
          },
          header.id
        );
      }) }, headerGroup.id)) }),
      hasNoData && /* @__PURE__ */ jsx3(Tbody, { children: /* @__PURE__ */ jsx3(Tr, { children: /* @__PURE__ */ jsx3(Td, { colSpan: columns.length, textAlign: "center", children: "Keine Daten" }) }) }),
      !loading ? /* @__PURE__ */ jsx3(Tbody, { children: table.getRowModel().rows.map((row) => {
        const original = row.original || {};
        const dataTestId2 = [
          original?.__typename?.toLowerCase?.(),
          original?.id || row?.id
        ]?.filter(Boolean)?.join("-");
        const onClickProps = onClick ? {
          _hover: {
            bg: "gray.100",
            cursor: "pointer"
          },
          ...activeRow === row.id && {
            bg: "gray.100"
          },
          onClick: () => {
            setActiveRow(row.id);
            onClick(row);
          }
        } : {};
        return /* @__PURE__ */ jsx3(
          Tr,
          {
            "data-test-id": dataTestId2,
            onMouseEnter: () => onMouseEnter?.(row),
            onMouseLeave: () => onMouseLeave?.(row),
            ...onClickProps,
            children: row.getVisibleCells().map((cell, index) => {
              const meta = cell.column.columnDef.meta;
              const columnDef = cell.column.columnDef;
              const props = typeof columnDef?.props === "function" ? columnDef?.props?.(row?.original) : columnDef?.props || {};
              return /* @__PURE__ */ jsx3(
                Td,
                {
                  "data-test-id": cell.id,
                  isNumeric: meta?.isNumeric,
                  verticalAlign: "top",
                  ...props,
                  children: /* @__PURE__ */ jsx3(
                    SimpleGrid,
                    {
                      column: 1,
                      whiteSpace: columnDef?.whiteSpace ? columnDef?.whiteSpace : "normal",
                      children: /* @__PURE__ */ jsx3(GridItem, { children: activeRow === row.id && index === 0 && activeChecked ? /* @__PURE__ */ jsxs3(
                        chakra.div,
                        {
                          display: "flex",
                          alignItems: "center",
                          children: [
                            /* @__PURE__ */ jsx3(
                              FaCheck,
                              {
                                style: {
                                  marginRight: 5,
                                  color: "#3182CE"
                                }
                              }
                            ),
                            flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )
                          ]
                        }
                      ) : flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      ) })
                    }
                  )
                },
                cell.id
              );
            })
          },
          row.id
        );
      }) }) : /* @__PURE__ */ jsx3(Tbody, { children: Array.from({ length: loadingLength || pageSize }).map((_, key) => /* @__PURE__ */ jsx3(Tr, { w: "full", children: /* @__PURE__ */ jsx3(Td, { colSpan: columns.length, children: /* @__PURE__ */ jsx3(Skeleton, { height: "16px", my: "2px" }) }) }, key)) })
    ] }),
    !hasNoData && fetchData && /* @__PURE__ */ jsx3(DataTablePagination, { table, actualPageCount: pageIndex, loading })
  ] });
}

// src/ui/DataTable/DataTableControls.tsx
import { AiTwotoneEdit } from "react-icons/ai";
import { FiMoreHorizontal } from "react-icons/fi";
import { Link } from "react-router-dom";
import {
  IconButton as IconButton3,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  HStack as HStack3,
  Box as Box3
} from "@chakra-ui/react";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
function EditRowButton(props) {
  return /* @__PURE__ */ jsx4(
    IconButton3,
    {
      variant: "link",
      icon: /* @__PURE__ */ jsx4(AiTwotoneEdit, {}),
      ...props,
      "aria-label": props["aria-label"] || "bearbeiten"
    }
  );
}
function EditRow(props) {
  return /* @__PURE__ */ jsx4(
    IconButton3,
    {
      "aria-label": props["aria-label"] || "bearbeiten",
      as: Link,
      variant: "link",
      icon: /* @__PURE__ */ jsx4(AiTwotoneEdit, {}),
      ...props
    }
  );
}
EditRow.FlexEnd = (props) => /* @__PURE__ */ jsx4(HStack3, { justify: "flex-end", h: "full", ...props });
function EditRowMenu({ children, ...props }) {
  return /* @__PURE__ */ jsx4(Box3, { children: /* @__PURE__ */ jsxs4(Menu, { children: [
    /* @__PURE__ */ jsx4(
      MenuButton,
      {
        as: IconButton3,
        "aria-label": "Options",
        icon: /* @__PURE__ */ jsx4(FiMoreHorizontal, {}),
        variant: "ghost",
        size: "sm",
        onClick: (event) => {
          event.stopPropagation();
        },
        ...props
      }
    ),
    /* @__PURE__ */ jsx4(MenuList, { children })
  ] }) });
}
EditRowMenu.Item = ({ children, to, onClick, ...props }) => to ? /* @__PURE__ */ jsx4(
  MenuItem,
  {
    onClick: (event) => {
      event.stopPropagation();
      onClick?.();
    },
    children: /* @__PURE__ */ jsx4(Link, { to, children })
  }
) : /* @__PURE__ */ jsx4(
  MenuItem,
  {
    onClick: (event) => {
      event.stopPropagation();
      onClick?.();
    },
    ...props,
    children
  }
);
EditRowMenu.Divider = (props) => /* @__PURE__ */ jsx4(MenuDivider, { ...props });

// src/ui/PlusButton/PlusButton.tsx
import { Button as Button3, useMediaQuery, IconButton as IconButton4, Tooltip } from "@chakra-ui/react";
import { AiOutlinePlus } from "react-icons/ai";
import { Link as Link2 } from "react-router-dom";
import { Fragment as Fragment2, jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var PlusButton = ({ to, mq, ...props }) => {
  const mediaQuery = typeof mq === "boolean" ? "(min-width: 1780px)" : `(min-width: ${mq}px)`;
  const [isMedia] = useMediaQuery(mediaQuery);
  if (mq) {
    return /* @__PURE__ */ jsxs5(Fragment2, { children: [
      !isMedia && /* @__PURE__ */ jsx5(Tooltip, { label: props?.children, hasArrow: true, placement: "top", children: /* @__PURE__ */ jsx5(
        IconButton4,
        {
          "aria-label": `add ${props.children}`,
          colorScheme: "blue",
          icon: /* @__PURE__ */ jsx5(AiOutlinePlus, {}),
          ...props
        }
      ) }),
      isMedia && /* @__PURE__ */ jsx5(
        Button3,
        {
          rightIcon: /* @__PURE__ */ jsx5(AiOutlinePlus, {}),
          colorScheme: "blue",
          px: 5,
          ...to && !("as" in props) && { as: Link2, to },
          ...props
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsx5(
    Button3,
    {
      rightIcon: /* @__PURE__ */ jsx5(AiOutlinePlus, {}),
      colorScheme: "blue",
      px: 5,
      ...to && !("as" in props) && { as: Link2, to },
      ...props
    }
  );
};

// src/ui/InfiniteDataTable/InfiniteDataTable.tsx
import * as React4 from "react";
import { Table as Table2, Tbody as Tbody2, Tr as Tr3, Td as Td2, Box as Box4, Skeleton as Skeleton2, useOutsideClick, Progress, SimpleGrid as SimpleGrid2, GridItem as GridItem2 } from "@chakra-ui/react";
import {
  useReactTable as useReactTable2,
  flexRender as flexRender3,
  getCoreRowModel as getCoreRowModel2,
  getSortedRowModel as getSortedRowModel2
} from "@tanstack/react-table";

// src/ui/InfiniteDataTable/TableHead.tsx
import { Thead as Thead2, Tr as Tr2, Th as Th2, chakra as chakra2, useColorModeValue as mode3 } from "@chakra-ui/react";
import { TriangleDownIcon as TriangleDownIcon2, TriangleUpIcon as TriangleUpIcon2 } from "@chakra-ui/icons";
import { flexRender as flexRender2 } from "@tanstack/react-table";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
function TableHead({ headerGroups = [], ...props }) {
  return /* @__PURE__ */ jsx6(Thead2, { bg: mode3("gray.50", "gray.800"), ...props, children: headerGroups.map((headerGroup) => /* @__PURE__ */ jsx6(Tr2, { children: headerGroup.headers.map((header) => {
    const meta = header.column.columnDef.meta;
    const columnDef = header.column.columnDef;
    return /* @__PURE__ */ jsxs6(
      Th2,
      {
        overflow: "hidden",
        textOverflow: "ellipsis",
        userSelect: "none",
        colSpan: header.colSpan,
        onClick: header.column.getToggleSortingHandler(),
        isNumeric: meta?.isNumeric,
        ...columnDef?.width && { width: typeof columnDef?.width === "number" ? `${columnDef?.width}px` : columnDef?.width },
        children: [
          header.isPlaceholder ? null : header.id === "controls" ? null : flexRender2(
            header.column.columnDef.header,
            header.getContext()
          ),
          /* @__PURE__ */ jsx6(chakra2.span, { pl: "4", visibility: header.column.getIsSorted() ? "revert" : "hidden", children: header.column.getIsSorted() === "desc" ? /* @__PURE__ */ jsx6(TriangleDownIcon2, { "aria-label": "sorted descending" }) : /* @__PURE__ */ jsx6(TriangleUpIcon2, { "aria-label": "sorted ascending" }) })
        ]
      },
      header.id
    );
  }) }, headerGroup.id)) });
}

// src/ui/InfiniteDataTable/InfiniteDataTable.tsx
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
function InfiniteDataTable({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dataTestId,
  next,
  hasMore = true,
  data = [],
  columns,
  hiddenColumns = [],
  onSortChange,
  totalCount: totalDBRowCount = 0,
  pageCount,
  loading = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  pageSize = 25,
  activeRow: controlledActiveRow = "",
  enableSorting = false
}) {
  const tableContainerRef = React4.useRef(null);
  const totalFetched = data.length;
  const ref = React4.useRef();
  const [activeRow, setActiveRow] = React4.useState(controlledActiveRow);
  useOutsideClick({
    ref,
    handler: () => setActiveRow("")
  });
  const defaultData = React4.useMemo(() => [], []);
  const [sortBy, setSortBy] = React4.useState([]);
  const cols = React4.useMemo(() => enableSorting ? columns : columns.map((col) => ({ ...col, enableSorting })), [enableSorting, columns]);
  const table = useReactTable2({
    data: data ?? defaultData,
    columns: cols,
    pageCount: pageCount ?? -1,
    state: {
      sorting: sortBy,
      // pagination,
      columnVisibility: hiddenColumns.reduce((acc, column) => ({ ...acc, [column]: false }), {})
    },
    getCoreRowModel: getCoreRowModel2(),
    onSortingChange: setSortBy,
    getSortedRowModel: getSortedRowModel2(),
    manualPagination: true
  });
  React4.useEffect(() => {
    let isMounted = true;
    if (isMounted && sortBy?.length && typeof onSortChange === "function") {
      onSortChange?.({ sortBy });
    }
    return () => {
      isMounted = false;
    };
  }, [sortBy, onSortChange]);
  const hasNoData = !loading && data.length === 0;
  const pageCountIsZero = pageCount === 0;
  const isLoading = !hasMore && loading && pageCountIsZero;
  const fetchMoreOnBottomReached = React4.useCallback(
    (containerRefElement) => {
      if (containerRefElement) {
        const { scrollHeight, scrollTop, clientHeight } = containerRefElement;
        const cond = scrollHeight - scrollTop - clientHeight < 300 && !isLoading && totalFetched < totalDBRowCount;
        console.log("fetchMoreOnBottomReached", {
          cond,
          hasMore,
          containerRefElement,
          clientHeight,
          scrollHeight,
          scrollTop,
          totalFetched,
          totalDBRowCount
        });
        if (cond) {
          next?.();
        }
      }
    },
    [next, isLoading, totalFetched, totalDBRowCount, hasMore]
  );
  React4.useEffect(() => {
    fetchMoreOnBottomReached(tableContainerRef.current);
  }, [fetchMoreOnBottomReached]);
  if (isLoading) {
    return /* @__PURE__ */ jsxs7(Table2, { borderWidth: "1px", "data-test-id": dataTestId, position: "relative", children: [
      /* @__PURE__ */ jsx7(TableHead, { headerGroups: table.getHeaderGroups() }),
      /* @__PURE__ */ jsx7(Tbody2, { children: Array.from({ length: pageSize }).map((_, key) => /* @__PURE__ */ jsx7(Tr3, { w: "full", children: /* @__PURE__ */ jsx7(Td2, { colSpan: columns.length, children: /* @__PURE__ */ jsx7(Skeleton2, { height: "16px", my: "2px" }) }) }, key)) })
    ] });
  }
  return /* @__PURE__ */ jsxs7(Box4, { position: "relative", children: [
    /* @__PURE__ */ jsx7(
      Box4,
      {
        h: "85vh",
        overflow: "auto",
        onScroll: (e) => fetchMoreOnBottomReached(e.target),
        ref: tableContainerRef,
        children: /* @__PURE__ */ jsxs7(Table2, { borderWidth: "1px", "data-test-id": dataTestId, position: "relative", children: [
          /* @__PURE__ */ jsx7(TableHead, { headerGroups: table.getHeaderGroups(), position: "sticky", top: "-1", zIndex: "42" }),
          hasNoData && /* @__PURE__ */ jsx7(Tbody2, { children: /* @__PURE__ */ jsx7(Tr3, { children: /* @__PURE__ */ jsx7(Td2, { colSpan: columns.length, textAlign: "center", children: "Keine Daten" }) }) }),
          /* @__PURE__ */ jsx7(Tbody2, { children: table.getRowModel().rows.map((row) => {
            const original = row.original || {};
            const dataTestId2 = [
              original?.__typename?.toLowerCase?.(),
              original?.id || row?.id
            ]?.filter(Boolean)?.join("-");
            const onClickProps = onClick ? {
              _hover: {
                bg: "gray.100",
                cursor: "pointer"
              },
              ...activeRow === row.id && {
                bg: "gray.100"
              },
              onClick: () => {
                setActiveRow(row.id);
                onClick(row);
              }
            } : {};
            return /* @__PURE__ */ jsx7(
              Tr3,
              {
                "data-test-id": dataTestId2,
                onMouseEnter: () => onMouseEnter?.(row),
                onMouseLeave: () => onMouseLeave?.(row),
                ...onClickProps,
                children: row.getVisibleCells().map((cell, idx) => {
                  const meta = cell.column.columnDef.meta;
                  const columnDef = cell.column.columnDef;
                  return /* @__PURE__ */ jsxs7(
                    Td2,
                    {
                      ref,
                      isNumeric: meta?.isNumeric,
                      verticalAlign: "top",
                      ...columnDef?.width && { width: typeof columnDef?.width === "number" ? `${columnDef?.width}px` : columnDef?.width },
                      children: [
                        "  ",
                        /* @__PURE__ */ jsx7(SimpleGrid2, { column: 1, whiteSpace: columnDef?.whiteSpace ? columnDef?.whiteSpace : "normal", children: /* @__PURE__ */ jsx7(GridItem2, { children: flexRender3(cell.column.columnDef.cell, cell.getContext()) }) })
                      ]
                    },
                    cell.id
                  );
                })
              },
              row.id
            );
          }) })
        ] })
      }
    ),
    loading && /* @__PURE__ */ jsx7(Progress, { size: "xs", colorScheme: "cyan", isIndeterminate: true })
  ] });
}

// src/ui/InfiniteDataTable/infiniteDataTableMachine.ts
import { assign, createMachine } from "xstate";
var infiniteDataTableMachine = createMachine(
  {
    id: "infiniteData",
    initial: "idle",
    context: {
      data: [],
      limit: 30,
      pageCount: 0,
      totalCount: 0,
      currentPage: 0,
      variables: {}
    },
    states: {
      idle: {
        entry: assign({
          currentPage: 0
        }),
        invoke: {
          id: "initialFetch",
          src: "fetchData",
          onDone: {
            target: "wait",
            actions: ["toggleLoading", "initial"]
          }
        }
      },
      wait: {
        entry: "toggleLoading",
        on: {
          FETCH_MORE: {
            target: "more",
            cond: ({ currentPage, pageCount }) => currentPage < pageCount
          },
          FETCH_INITIAL: "idle"
        }
      },
      more: {
        invoke: {
          id: "fetchMore",
          src: "fetchData",
          onDone: {
            target: "wait",
            actions: "concat"
          }
        }
      },
      final: {
        type: "final"
      }
    }
  },
  {
    actions: {
      initial: assign(({ currentPage }, event) => ({
        data: event?.data?.data?.items?.items,
        pageCount: event?.data?.data?.items?.pageInfo?.pageCount,
        totalCount: event?.data?.data?.items?.pageInfo?.totalCount,
        currentPage: currentPage + 1,
        variables: event?.data?.variables
      })),
      concat: assign((ctx, event) => ({
        data: ctx.data.concat(event?.data?.data?.items?.items),
        pageCount: event?.data?.data?.items?.pageInfo?.pageCount,
        totalCount: event?.data?.data?.items?.pageInfo?.totalCount,
        currentPage: ctx?.currentPage + 1,
        variables: event?.data?.variables
      }))
    }
  }
);

// src/ui/Card/Card.tsx
import {
  Box as Box5,
  Heading as Heading2,
  HStack as HStack4,
  useColorModeValue as useColorModeValue2,
  VStack
} from "@chakra-ui/react";
import { jsx as jsx8 } from "react/jsx-runtime";
var Card = (props) => {
  return /* @__PURE__ */ jsx8(Box5, { bg: useColorModeValue2("white", "gray.700"), shadow: "base", w: "full", ...props });
};
var CardHeader = (props) => {
  return /* @__PURE__ */ jsx8(HStack4, { alignItems: "center", p: 6, flex: 1, ...props });
};
var CardHeading = (props) => /* @__PURE__ */ jsx8(
  Heading2,
  {
    display: "flex",
    alignItems: "center",
    as: "h5",
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 7,
    w: "full",
    ...props
  }
);
var CardActions = (props) => /* @__PURE__ */ jsx8(HStack4, { w: "full", justify: "flex-end", minH: 10, ...props });
var CardContent = (props) => /* @__PURE__ */ jsx8(VStack, { align: "stretch", spacing: 0, ...props });
Card.Content = CardContent;
Card.Header = CardHeader;
Card.Heading = CardHeading;
Card.Actions = CardActions;

// src/ui/SectionCard/SectionCard.tsx
import React5, { cloneElement } from "react";
import { HiChevronUp, HiChevronDown } from "react-icons/hi";
import styled from "@emotion/styled";
import {
  Flex,
  Box as Box6,
  Heading as Heading3,
  useColorModeValue as useColorModeValue3,
  HStack as HStack5,
  chakra as chakra3,
  Collapse
} from "@chakra-ui/react";
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var CollapseTransition = styled(Collapse)`
  overflow: ${({ in: isEnabled }) => isEnabled ? "initial !important" : "hidden"};
`;
var SectionCard = React5.forwardRef(
  ({
    title,
    children,
    actions = [],
    body = true,
    rounded = 3,
    borderTopColor,
    isCollapsible = false,
    ...props
  }, ref) => {
    const p = body ? 5 : 0;
    const [isOpen, setIsOpen] = React5.useState(true);
    const getCollapsibleProps = () => ({
      ...isCollapsible && {
        onClick: () => setIsOpen((prev) => !prev),
        cursor: "pointer",
        userSelect: "none"
      }
    });
    return /* @__PURE__ */ jsxs8(
      Box6,
      {
        ...borderTopColor && {
          borderTopWidth: 2,
          borderTopColor
        },
        rounded,
        bg: useColorModeValue3("white", "gray.700"),
        shadow: "base",
        w: "full",
        maxW: "768px",
        ...props,
        children: [
          (title || actions.length) && /* @__PURE__ */ jsxs8(
            HStack5,
            {
              "data-testid": "section-card-header",
              ...children && { borderBottomWidth: 1, borderColor: "gray.200" },
              ...getCollapsibleProps(),
              alignItems: "center",
              p: "26px 24px 25px 24px",
              flex: 1,
              children: [
                /* @__PURE__ */ jsx9(Heading3, { ref, display: "flex", alignItems: "center", as: "h5", fontSize: 18, fontWeight: 700, lineHeight: 7, w: "full", children: title }),
                /* @__PURE__ */ jsxs8(HStack5, { w: "full", justify: "flex-end", minH: 10, children: [
                  isCollapsible && /* @__PURE__ */ jsxs8(chakra3.span, { px: 3, children: [
                    " ",
                    isOpen ? /* @__PURE__ */ jsx9(HiChevronUp, {}) : /* @__PURE__ */ jsx9(HiChevronDown, {}),
                    " "
                  ] }),
                  actions.map((action, key) => cloneElement(action, { key: action?.props?.children || key }))
                ] })
              ]
            }
          ),
          /* @__PURE__ */ jsx9(CollapseTransition, { animateOpacity: true, in: isOpen, children: /* @__PURE__ */ jsxs8(Flex, { p, flexDir: "column", children: [
            " ",
            children,
            " "
          ] }) })
        ]
      }
    );
  }
);
export {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardHeading,
  CollapseTransition,
  DataTable,
  EditRow,
  EditRowButton,
  EditRowMenu,
  InfiniteDataTable,
  SignIn as Login,
  PlusButton,
  SectionCard,
  TableHead,
  infiniteDataTableMachine,
  themes_exports as themes,
  useCustomEvent
};
//# sourceMappingURL=index.js.map